import { SvgIcon, Tooltip } from "@mui/material";
import ToggleFab from "../ToggleFab";
import { useFurnituresStore } from "@src/v3.0.0/store/furnitures/store";
import ChairIcon from '@mui/icons-material/Chair';
import l10n from "@src/v3.0.0/lib/l10n";

export function CanvasFurnituresTool() {
  const { drawerIsShown, setDrawerShown } = useFurnituresStore();
  
  if (l10n?.wppr_cjs_ctrl_furnitures_active === "no") {
    return null;
  }

  return (
    <Tooltip title="Mostra oggetti" placement="top">
      <ToggleFab
        active={drawerIsShown}
        onClick={() => setDrawerShown(!drawerIsShown)}
      >
        <SvgIcon component={ChairIcon} inheritViewBox />
      </ToggleFab>
    </Tooltip>
  )
}